import Reception from './reception';

export default Reception;
